import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';
import { useTranslation } from 'react-i18next';

const TooltipMetronome = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation();

  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent className='w-64' sideOffset={8} side='top' variant='zinc'>
        <div className='w-full m-2'>
          <div className='space-y-1'>
            <p className='text-sm'>{t('tooltip.metronome.help')}</p>
          </div>
        </div>
      </TooltipContent>
    </Tooltip>
  );
};

export default TooltipMetronome;
